import React from 'react';

import { dashboardConfig } from 'config/routeConfigurations/dashboardConfig/dashboardConfig';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { PageNotFound } from 'components/common/ErrorPages/pageNotFound';
import NoAccess from 'components/common/NoAccess/noAccess';

import { reportingConfig } from 'components/Dashboards/Reporting/reportingConfig';
import { Responsive } from 'components/Dashboards/responsive';
import { ConfirmWidgetPage } from 'components/pages/ConfirmWidgetPage/ConfirmWidgetPage';
import { ConfirmWidgetPageWrapper } from 'components/pages/ConfirmWidgetPage/ConfirmWidgetPageWrapper';
import { CreateReportPage } from 'components/pages/CreateReportPage/CreateReportPage';
import { ReportPage } from 'components/pages/ReportPage/ReportPage';
import { ReportingHomePage } from 'components/pages/ReportingHomePage/ReportingHomePage';

const ReportingRoutes = () => {
    const { path } = useRouteMatch();

    return (
        <Responsive title={dashboardConfig.reporting.title} isReporting={true}>
            <Switch>
                {/* Reports home page */}
                <Route exact path={path} component={ReportingHomePage} />
                {/* Report creation flow */}
                <Route path={`${path}/${reportingConfig.create.link}`} component={CreateReportPage} />
                {/* Add new widget to report */}
                <Route
                    path={`${path}/:reportId([0-9-]+)/${reportingConfig.confirmWidget.link}/:componentKey`}
                    component={ConfirmWidgetPage}
                />
                {/* Edit widget inside saved report */}
                <Route
                    path={`${path}/:reportId([0-9-]+)/${reportingConfig.editWidget.link}/:widgetId([0-9-]+)`}
                    component={ConfirmWidgetPageWrapper}
                />
                {/* Current selected report view */}
                <Route path={`${path}/:reportId([0-9-]+)`} component={ReportPage} />

                <Route exact path={`${path}/no-access`} component={NoAccess} />
                <Route path={'*'} component={PageNotFound} />
            </Switch>
        </Responsive>
    );
};
export default ReportingRoutes;
